import React, {useRef, useState} from "react";
import {Badge, Button, Card} from "react-bootstrap";
export default function FileUploader({
                                         file,
                                         setFile
                                     }) {
    const inputRef = useRef(null);
    const [dragging, setDragging] = useState(false);
    // =====================================================
    // VALIDATE FILE
    // =====================================================
    const validateFile = (selected) => {
        if (!selected)
            return;
        const allowed = [
            "image/jpeg",
            "image/png",
            "image/jpg",
            "application/pdf"
        ];
        if (!allowed.includes(selected.type)) {
            alert(
                "Only JPG, PNG and PDF files are allowed."
            );
            return;
        }
        if (selected.size > 10 * 1024 * 1024) {
            alert(
                "Maximum file size is 10 MB."
            );
            return;
        }
        setFile(selected);
    };
    // =====================================================
    // INPUT CHANGE
    // =====================================================
    const handleChange = (e) => {
        validateFile(
            e.target.files[0]
        );
    };
    // =====================================================
    // DROP EVENTS
    // =====================================================
    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        validateFile(
            e.dataTransfer.files[0]
        );
    };
    return (
        <Card

            className={
                dragging
                    ?
                    "border-primary"
                    :
                    ""
            }

        >

            <Card.Body>


                <h6>
                    📂 Upload Identity Document
                </h6>


                <div


                    onDragOver={(e) => {
                        e.preventDefault();
                        setDragging(true);
                    }}


                    onDragLeave={() => {
                        setDragging(false);
                    }}


                    onDrop={handleDrop}


                    style={{
                        border: "2px dashed #ccc",
                        borderRadius: "15px",
                        padding: "30px",
                        textAlign: "center",
                        cursor: "pointer"
                    }}


                    onClick={() => {
                        inputRef.current.click();
                    }}


                >


                    <h4>
                        📄
                    </h4>


                    <p>

                        Drag & Drop document here

                    </p>


                    <small>

                        JPG / PNG / PDF

                    </small>


                    <input

                        ref={inputRef}

                        type="file"

                        hidden

                        accept="image/*,.pdf"

                        onChange={handleChange}

                    />


                </div>


                {
                    file && (
                        <div className="mt-3">


                            <Badge bg="success">

                                {file.name}

                            </Badge>


                            <Button

                                size="sm"

                                variant="danger"

                                className="ms-2"


                                onClick={() => {
                                    setFile(null);
                                }}

                            >

                                Remove


                            </Button>


                        </div>
                    )
                }


            </Card.Body>


        </Card>
    );
}